import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M4.5 15a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h1Zm16 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5h1ZM8.5 3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5Zm12 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5Zm-8.74 11.911a.5.5 0 0 0 .707 0l1.722-1.722a2.936 2.936 0 1 0-4.152 0l1.723 1.722Zm3.616-.535-2.91 2.908a.5.5 0 0 1-.706 0l-2.91-2.91a4.613 4.613 0 1 1 6.526.002Zm-3.263-2.005a1.259 1.259 0 1 1 0-2.517 1.259 1.259 0 0 1 0 2.517Z' />
  </>,
  'SmartGroup'
)
